/**
 * Blinkit-style skeleton placeholder for product cards. Drop-in replacement
 * while a product list is loading; preserves layout so cards don't pop in.
 */
import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

interface Props {
  count?: number;
}

export const ProductCardSkeleton: React.FC<Props> = ({ count = 8 }) => {
  return (
    <SkeletonTheme baseColor="#eef0f3" highlightColor="#f7f8fa">
      <div
        className="grid"
        style={{
          gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
          gap: '14px',
        }}
      >
        {Array.from({ length: count }).map((_, i) => (
          <div
            key={i}
            style={{
              border: '1px solid #eef0f3',
              borderRadius: 14,
              padding: 12,
              background: '#fff',
            }}
          >
            <Skeleton height={140} borderRadius={10} />
            <div style={{ marginTop: 10 }}>
              <Skeleton height={14} width="80%" />
              <Skeleton height={12} width="50%" style={{ marginTop: 6 }} />
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10 }}>
                <Skeleton height={20} width={60} />
                <Skeleton height={28} width={56} borderRadius={8} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </SkeletonTheme>
  );
};

export default ProductCardSkeleton;

